import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import ChiikiDetailDialog from "./ChiikiDetailDialog";
import ChiikiSearchForm from "./ChiikiSearchForm";
import ChiikiSearchResult from "./ChiikiSearchResult";
import {
  DEFAULT_FORM,
  INITIAL_VIEW_STATE,
  TITLE,
} from "./constants";
import { searchChiiki } from "./searchChiiki";
import { useChiikiCsvData } from "./useChiikiCsvData";
import "./ChiikiSearch.css";

export default function ChiikiSearch() {
  const [form, setForm] = useState(DEFAULT_FORM);
  const [dialogType, setDialogType] = useState(null);
  const [viewState, setViewState] = useState(INITIAL_VIEW_STATE);

  const { context, loading, loadError } = useChiikiCsvData();

  useEffect(() => {
    document.body.classList.add("chiiki-search-page");
    return () => {
      document.body.classList.remove("chiiki-search-page");
    };
  }, []);

  useEffect(() => {
    if (loadError) {
      setViewState({ status: "error", message: loadError });
    }
  }, [loadError]);

  const isButtonDisabled = loading || !form.law;

  const updateForm = (field, value) => {
    setForm((current) => ({ ...current, [field]: value }));
  };

  const onSearch = () => {
    setViewState(searchChiiki(context, form, loadError));
  };

  return (
    <div className="chiiki-page">
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <div className="chiiki-main">
        <div className="chiiki-head">
          <img
            src={`${process.env.PUBLIC_URL}/litalico_logo_254_90.png`}
            alt="LITALICO"
          />
        </div>
        <div className="chiiki-search ui-widget">
          <div className="subject">地域区分を調べる</div>
          <div className="text">
            こちらのページでは地域区分の等級と区分コードを調べることができます。
          </div>
          <ChiikiSearchForm
            form={form}
            disabled={isButtonDisabled}
            onFormChange={updateForm}
            onSearch={onSearch}
            onShowLawDialog={() => setDialogType("law")}
            onShowKeikaDialog={() => setDialogType("keika")}
          />
          <ChiikiSearchResult viewState={viewState} />
        </div>
        <div className="chiiki-foot">©LITALICO Inc.</div>
      </div>

      <ChiikiDetailDialog type={dialogType} onClose={() => setDialogType(null)} />
    </div>
  );
}
